<!--
  Общая панель управления таблицей.
  Собирает primary-действия, настройки колонок и dropdown действий в одном месте,
  чтобы таблицы не дублировали локальную разметку и стили center-nav.

-->
<template>
  <div
    class="table-toolbar"
    :style="{ marginTop: topMargin }"
  >
    <div class="table-toolbar__left">
      <slot />
    </div>

    <div class="table-toolbar__right">
      <slot name="right-before" />

      <TableSettingsButton
        v-if="showSettings"
        @open-settings="$emit('open-settings')"
      />
      <BaseDropdownButton
        v-if="actions.length"
        trigger-text="Действия"
        :items="actions"
        :table-style="true"
        :disabled="actionsDisabled"
      />
    </div>
  </div>
</template>

<script>
import TableSettingsButton from "@/components/Table/TableSettingsButton.vue";

export default {
  name: "TableToolbar",
  components: { TableSettingsButton },
  props: {
    showSettings: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    actionsDisabled: {
      type: Boolean,
      default: false,
    },
    // Дополнительный отступ перед панелью. По умолчанию используется CSS-значение.
    topMargin: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["open-settings"],
};
</script>

<style scoped>
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.table-toolbar__left,
.table-toolbar__right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.table-toolbar__right {
  margin-left: auto;
}

</style>
